module.exports = __webpack_public_path__ + "static/img/grac-oidd-competition-proposal.09ea779.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/visual-marketing/grac-oidd-competition-proposal.jpg
// module id = gx92
// module chunks = 0